// extracted by css-extract-rspack-plugin
export default {"header":"HJ3fje"};